import React, { useContext } from 'react';
import FooterLogo from '../../assets/logos/FooterLogo';
import themeContext from '../../context/theme/themeContext';
import { config } from '../../config/config';
import { FooterArrowIcon, SocialIcons } from '../../assets/icons';
import { isActiveRoute } from '../../routes';
import { NavLink, useLocation } from 'react-router-dom';
import { useWeb3React } from '@web3-react/core';
import { SupportedChains } from '../../config/constants';

const footerLinks = [
    {
        to: '/',
        label: 'Spool App',
    },
    {
        to: '/platform-summary',
        label: 'Your Vault',
    },
    {
        to: '/staking',
        label: 'Spool Staking',
    },
    {
        to: '/egov',
        label: 'E-Gov',
    },
];

const Footer: React.FC = () => {
    const { theme } = useContext(themeContext);

    const { chainId } = useWeb3React();

    const location = useLocation();

    return (
        <footer className={theme}>
            <div className='container'>
                <div className='logo-container'>
                    <FooterLogo />
                    <div className='details'>
                        <h4>Spool</h4>
                    </div>
                </div>
                <div className='links-container'>
                    <div className='links'>
                        {footerLinks.map(({ to, label }) => {
                            if (
                                chainId === SupportedChains.ARBITRUM_ONE &&
                                (label === 'Spool Staking' || label === 'E-Gov')
                            )
                                return null;
                            return (
                                <NavLink
                                    exact
                                    activeClassName='active'
                                    className={
                                        isActiveRoute(location.pathname, to)
                                            ? 'active'
                                            : undefined
                                    }
                                    to={
                                        chainId === SupportedChains.ARBITRUM_ONE &&
                                        label === 'Your Vault'
                                            ? '/your-spools?network=arbitrum'
                                            : chainId === SupportedChains.ARBITRUM_ONE
                                            ? to + '?network=arbitrum'
                                            : to
                                    }
                                    key={label}
                                >
                                    <FooterArrowIcon />
                                    <span>{label}</span>
                                </NavLink>
                            );
                        })}
                    </div>
                </div>
                <div className='social-media-container'>
                    <p>
                        <span>&copy;</span> {new Date().getFullYear()} Spool. <br /> All
                        rights reserved.
                    </p>
                    <div className='icons-container'>
                        {Object.entries(config.socialMedias).map(([name, link]) => (
                            <a
                                key={name}
                                href={link}
                                target='_blank'
                                rel='noreferrer noopener'
                            >
                                {SocialIcons[name]}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
